
document.addEventListener('DOMContentLoaded', function () {
    // Get modal elements
    var modal = document.getElementById("imageModal");
    var modalImg = document.getElementById("modalImage");
    var popupLink = document.getElementById("popup-link");
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks the link, open the modal
    popupLink.onclick = function() {
      modal.style.display = "flex"; // Display the modal only on click
      modalImg.src = "https://cdn.shopify.com/s/files/1/0071/9755/6794/files/download.jpg?v=1729211883";
    };

    // When the user clicks on the close button, close the modal
    span.onclick = function() {
      modal.style.display = "none";
    };

    // When the user clicks anywhere outside the image, close the modal
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  });
  document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('search-input');
    const searchButton = document.getElementById('search-button');
    const clearButton = document.getElementById('clear-button');
    const searchResults = document.getElementById('search-results');

    // Function to trigger the search
    function performSearch() {
      const query = searchInput.value;

      if (query.length > 2) { // Optional: Only search after 2 characters
        fetch(`/search?q=${encodeURIComponent(query)}&type=article`)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const articles = doc.querySelectorAll('.c-blog__post');
            
            // Clear previous results
            searchResults.innerHTML = '';

            // Create a container for the grid layout
            const resultsContainer = document.createElement('div');
            resultsContainer.classList.add('c-blog__posts');

            if (articles.length > 0) {
              articles.forEach(article => {
                // Clone each article and append to the results container
                resultsContainer.appendChild(article.cloneNode(true));
              });
            } else {
              // If no articles found, show a message
              resultsContainer.innerHTML = '<p>No articles found.</p>';
            }

            // Append the results container to the search results div
            searchResults.appendChild(resultsContainer);
            searchResults.style.display = 'block'; // Show results container
            clearButton.style.display = 'inline-block'; // Show clear button
          })
          .catch(error => {
            console.error('Error fetching search results:', error);
          });
      } else {
        // Clear results if the input is too short
        searchResults.innerHTML = '';
        searchResults.style.display = 'none'; // Hide results container
      }
    }

    // Search button functionality
    searchButton.addEventListener('click', performSearch);

    // Trigger search on pressing Enter
    searchInput.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        performSearch();
      }
    });

    // Clear button functionality
    clearButton.addEventListener('click', function() {
      searchResults.innerHTML = ''; // Clear the results
      searchResults.style.display = 'none'; // Hide results container
      clearButton.style.display = 'none'; // Hide clear button
      searchInput.value = ''; // Clear input field
    });
  });
